// mui
import { Card, Typography, CardContent, Box } from '@mui/material';
// components
import SavingsForm from './SavingsForm';

export default function SavingsCard() {
  return (
    <Card sx={{ width: '65%', margin: 'auto', borderRadius: '16px' }}>
      <CardContent sx={{ backgroundColor: 'white' }}>
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="h6" color="#20C67F" sx={{ fontFamily: 'Rubik', my: 1 }}>
            Instant Savings Calculator
          </Typography>
          <Typography sx={{ fontSize: 14, fontFamily: 'Rubik', fontWeight: 300, my: 1 }}>
            Select the vessel type and speed from the dropdown menus to calculate the fuel and emission estimations.
          </Typography>
        </Box>
        <SavingsForm />
      </CardContent>
    </Card>
  )
};